export interface Special {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  description: string;
  movieIds: string[];
}

export const specials: Special[] = [
  {
    id: "s1",
    title: "紫罗兰时代 · 年度高分百合电影",
    subtitle: "把最细腻的情感，留给最值得的银幕时光",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20collection%20cover%20artwork%20of%20a%20violet%20field%20at%20golden%20hour%2C%20drifting%20flower%20petals%20and%20soft%20light%20leaks%2C%20mauve%20and%20blush%20pastel%20tones%2C%20refined%20romantic%20mood%2C%20cinematic%20film%20grain%2C%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20soft%20lighting&width=1000&height=640&seq=baihe-sp-01&orientation=landscape",
    description:
      "从《雨后花园》到《玻璃花房》，这些作品用克制而深情的笔触，重新定义了爱情片的表达边界。它们不急着给出答案，而是邀请你慢慢走进两个人心照不宣的世界。",
    movieIds: ["1", "5", "11", "7"],
  },
  {
    id: "s2",
    title: "夏日限定 · 清新甜系剧集",
    subtitle: "一杯冷饮的温度，刚刚好适合慢慢喜欢上一个人",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20collection%20cover%20artwork%20of%20a%20breezy%20summer%20terrace%20with%20lemonade%20and%20flowers%2C%20bright%20coral%20pink%20and%20lilac%20tones%2C%20playful%20sweet%20romance%20mood%2C%20airy%20film%20grain%2C%20clean%20editorial%20composition%2C%20high%20detail%2C%20warm%20sunny%20lighting&width=1000&height=640&seq=baihe-sp-02&orientation=landscape",
    description:
      "如果你偏爱轻松明亮的节奏，这个专题就是为你准备的。面包店的清晨、咖啡店的小票、天台的野餐——烟火气里藏着最踏实的甜。",
    movieIds: ["2", "6", "8", "12"],
  },
  {
    id: "s3",
    title: "异国恋曲 · 亚洲与欧美百合精选",
    subtitle: "跨越地域的共鸣，情感从来不需要翻译",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20collection%20cover%20artwork%20of%20a%20vintage%20world%20map%20with%20pressed%20flowers%20and%20postcards%2C%20dusty%20violet%20and%20warm%20beige%20tones%2C%20nostalgic%20wanderlust%20romance%20mood%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20soft%20warm%20lighting&width=1000&height=640&seq=baihe-sp-03&orientation=landscape",
    description:
      "从首尔的蔷薇庄园到巴黎的爵士酒吧，从台北的旧书店到曼谷的夏日海岸。同一个主题，在不同的城市里，被讲出了截然不同的余韵。",
    movieIds: ["3", "4", "9", "10"],
  },
  {
    id: "s4",
    title: "初见心动 · 新剧速递",
    subtitle: "刚刚上线的新作，先看为敬",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20collection%20cover%20artwork%20of%20falling%20cherry%20blossom%20petals%20over%20a%20quiet%20street%2C%20pale%20pink%20and%20soft%20lavender%20tones%2C%20tender%20first%20love%20mood%2C%20delicate%20film%20grain%2C%20airy%20editorial%20composition%2C%20high%20detail%2C%20gentle%20spring%20lighting&width=1000&height=640&seq=baihe-sp-04&orientation=landscape",
    description:
      "本季最新上线的几部作品，涵盖电影与剧集。无论你想找一部能一口气看完的电影，还是想追一部每周都有新期待的剧，这里都有。",
    movieIds: ["11", "2", "5", "8"],
  },
];